import {
  ADD_SALES_LINE_DETAILS,
  UPDATE_SALES_LINE_DETAILS,
  GET_SALES_LINE_DETAILS,
  GET_SALES_LINE_DETAIL,
  DELETE_SALES_LINE_DETAILS,
  GET_STOCK,
  GET_SERIAL_WISE_HISTORY,
  GET_SERIAL_TO_WAREHOUS,
} from '../types';
import axios from '../../axios';
import { toast } from 'react-toastify';

export const addSalesLineDetails = (data) => async (dispatch) => {
  try {
    const response = await axios.post('/salesLineDetail', data);
    if (response.data.code === 1) {
      dispatch({ type: ADD_SALES_LINE_DETAILS, payload: response.data.data });
      setTimeout(() => {
        toast.success('Sales Line Detail added successfully!');
      }, 1000);
    }
    if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};

export const updateSalesLineDetails = (data) => async (dispatch) => {
  try {
    const response = await axios.post('/salesLineDetail', data);
    if (response.data.code === 1) {
      dispatch({
        type: UPDATE_SALES_LINE_DETAILS,
        payload: response.data.data,
      });
      setTimeout(() => {
        toast.success('Sales Line Detail updated successfully!');
      }, 1000);
    }
    if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};

export const deleteSalesLineDetails = (id) => async (dispatch) => {
  try {
    const response = await axios.post(`/salesLineDetail/delete/${id}`);
    if (response.data.code === 1) {
      dispatch({ type: DELETE_SALES_LINE_DETAILS, payload: id });
      setTimeout(() => {
        toast.success('Sales Line Detail deleted successfully!');
      }, 1000);
    }
    if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};

export const getSalesLineDetails = (params) => async (dispatch) => {
  try {
    const response = await axios.get('/salesLineDetail/all', { params });
    if (response.data.code === 1) {
      dispatch({
        type: GET_SALES_LINE_DETAILS,
        payload: response.data.data,
      });
    } else if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};

export const getSalesLineDetailsById = (id) => async (dispatch) => {
  try {
    const response = await axios.get(`/salesLineDetail/${id}`);
    if (response.data.code === 1) {
      dispatch({
        type: GET_SALES_LINE_DETAIL,
        payload: response.data.data,
      });
    } else if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};

export const getStock = (params) => async (dispatch) => {
  try {
    const response = await axios.get(`/salesLineDetail/stock`, { params });
    if (response.data.code === 1) {
      dispatch({
        type: GET_STOCK,
        payload: response.data.data,
      });
      return response.data.data;
    } else if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};

export const getSerialToWarehouse = (params) => async (dispatch) => {
  try {
    const response = await axios.get(`/salesLineDetail/stock`, { params });
    if (response.data.code === 1) {
      dispatch({
        type: GET_SERIAL_TO_WAREHOUS,
        payload: response.data.data,
      });
      return response.data.data; // Return the data for further use if needed
    } else if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};

export const getSerialWiseHistory = (params) => async (dispatch) => {
  try {
    const response = await axios.get(`/salesLineDetail/serialWiseHistory`, { params });
    if (response.data.code === 1) {
      dispatch({
        type: GET_SERIAL_WISE_HISTORY,
        payload: response.data.data,
      });
    } else if (response.data.code === 0) {
      setTimeout(() => {
        toast.error(response.data.message);
      }, 1000);
    }
  } catch (error) {
    if (error.response.data.message) {
      toast.error(error.response.data.message);
    }
  }
};
